// extracted by mini-css-extract-plugin
module.exports = {"grid":"stack-module--grid--1ptjE","tech":"stack-module--tech--1Gbet","lib":"stack-module--lib--j-1gd","tool":"stack-module--tool--a0caL","database":"stack-module--database--2uXox"};